<template>
  <v-alert color="rgba(0,0,0,0)">
    <h1 v-if="false" class="text-center display-2 my-8 font-weight-bold">Interests</h1>
    <div class="text-center">
      <div>
        <v-chip label x-large class="mr-2 mb-2">
          <h3 class="font-weight-regular">
            Sports
          </h3>
        </v-chip>
        <v-chip label x-large class="mr-2 mb-2">
          <h3 class="font-weight-regular">
            Music
          </h3>
        </v-chip>
        <v-chip label x-large class="mr-2 mb-2">
          <h3 class="font-weight-regular">
            Psychology
          </h3>
        </v-chip>
        <v-chip label x-large class="mr-2 mb-2">
          <h3 class="font-weight-regular">
            Education
          </h3>
        </v-chip>
        <v-chip label x-large class="mr-2 mb-2">
          <h3 class="font-weight-regular">
            Blockchain
          </h3>
        </v-chip>
        <v-chip label x-large class="mr-2 mb-2">
          <h3 class="font-weight-regular">
            Artificial Intelligence
          </h3>
        </v-chip>
      </div>
    </div>
  </v-alert>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: "InterestsComponent",
  components: {
    //
  },
});
</script>
